// extracted by mini-css-extract-plugin
export var cmtSData = "styles-module--cmt-s-data--85823";
export var cmtSData__container = "styles-module--cmt-s-data__container--92e66";
export var cmtSData__content = "styles-module--cmt-s-data__content--000a1";
export var cmtSData__contentInner = "styles-module--cmt-s-data__content-inner--27871";
export var cmtSData__dataItem = "styles-module--cmt-s-data__data-item--93a87";
export var cmtSData__dataItemSecondary = "styles-module--cmt-s-data__data-item-secondary--0107d";
export var cmtSData__observer = "styles-module--cmt-s-data__observer--4d171";
export var cmtSData__observerIntersecting = "styles-module--cmt-s-data__observer--intersecting--e0573";
export var cmtSData__wrapper = "styles-module--cmt-s-data__wrapper--6702f";